import { useEffect, useState } from 'react';
import { getCalendars } from 'services/api/calendars';
import type { CalendarTab } from './types';

interface UseCalendarTabsServiceProps {
  onSelectTab: (tab: string) => void;
}

export const useCalendarTabsService = ({ onSelectTab }: UseCalendarTabsServiceProps) => {
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState<CalendarTab[]>([]);

  useEffect(() => {
    setLoading(true);
    getCalendars()
      .then((res) => {
        const transformedTabs = res.map(({ id, name }) => ({
          key: id.toString(),
          name,
        }));
        setTabs(transformedTabs);
        onSelectTab(transformedTabs[0].key);
      })
      .finally(() => setLoading(false));
  }, [onSelectTab]);

  return { state: { loading, tabs } };
};
